import Header from "../components/header";
import DealDetails from "../components/DealDetails";
import Sidebar from "../components/sidebar";
import { Handshake} from "lucide-react";


const DealDetailsPage = () => {
  return (
    <div>
        <Header 
        title="Order"
            icon={<Handshake className="w-5 h-5" />}
        />
        <Sidebar />
      <DealDetails />
    </div>
  );
};

export default DealDetailsPage;